import { createFileRoute, redirect } from '@tanstack/react-router';
import AdminsPage from '@/app/admins/page';
import { getSessionJwt } from '@/services/auth';

export const Route = createFileRoute('/admins/')({
  component: AdminsPage,
  beforeLoad: () => {
    // Redirect to login if not authenticated
    if (!getSessionJwt()) {
      throw redirect({ to: '/login' });
    }
  },
});

